import { render, staticRenderFns } from "./TranslatableDescriptions.vue?vue&type=template&id=4f25856a&"
import script from "./TranslatableDescriptions.vue?vue&type=script&lang=ts&"
export * from "./TranslatableDescriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports